<template>
  <info-page>
    <div slot="info" class="apply-container" ref="applyContainer">
      <div class="info">
        <span class="intro">私募管理人一站式全方位综合管理平台</span>
      </div>
      <div class="form">
        <div class="title" style="padding-left:0.4rem;padding-right:0.4rem;">
          <p style="font-size:0.24rem;font-weight:400;color:rgba(255,255,255,1);">试用申请</p>
          <p v-if="!applySuccess" style="font-size:0.16rem;font-weight:400;color:rgba(255,255,255,1);line-height:0.24rem;margin-top:0.18rem;">只需上传名片，排排网工作人员会第一时间联系您</p>
        </div>
        <div class="form-content" v-if="!applySuccess" style="padding-left:0.4rem;padding-right:0.4rem;">
            <div style="border:1px dashed #999999;width:3.8rem;height:1.74rem;">
                <div v-if="form.visitingCard" class="pic-wrapper" style="width:100%;height:100%;">
                    <img :src="staticBasePath+form.visitingCard" @click="uploadBusinessCard" style="cursor: pointer;max-width: 100%;max-height: 100%;"/>
                </div>
                <template v-else>
                    <img src="./img/plus@2x.png" @click="uploadBusinessCard" style="display:block;cursor: pointer;width: 0.6rem;height: 0.6rem;margin:0.45rem auto 0.3rem auto;"/>
                    <p style="font-size:0.16rem;font-weight:400;color:rgba(153,153,153,1);line-height:0.24rem;white-space: nowrap;text-align: center;transform: scale(0.75) translateX(-10%);">图片格式：jpg、jpeg、gif、png、bmp，文件尺寸小于2M</p>
                </template>
            </div>
            <div class="submit-button" @click="applySubmit">{{submitLoading ? '申请中...' : '申请' }}</div>
            <div style="overflow:auto;text-align: right;padding-top: 0.2rem;padding-bottom: 0.3rem;">
                <span style="font-size:0.16rem;font-weight:400;color:rgba(153,153,153,1);display:inline-block;padding: 0.03rem 0.1rem;">已有账号？</span>
                <span class="login-btn" @click="toLogin()" style="font-size:0.16rem;font-weight:400;display:inline-block;padding: 0.03rem 0.1rem;border-radius:0.04rem;cursor: pointer;">立即登录</span>
            </div>
          <form ref="uploadFileForm" style="display: none">
            <input
              type="file"
              accept="image/*"
              name="visitingCard"
              ref="uploadFileInput"
              @change="uploadFileInputChange"
            >
          </form>
        </div>

        <div class="success-tip" v-else>
          <img src="../../assets/images/apply/success.png" alt class="success-img">
          <span class="success-text">申请成功</span>
          <span class="success-desc">后续将有排排网的工作人员与您取得联系开通试用</span>
        </div>
      </div>
    </div>
  </info-page>
</template>

<script>
import { getUrlParams } from "../../common/js/utils.js";
import infoPage from "../../common/components/comp/info-page.vue";
export default {
  components: {
    infoPage
  },
  data() {
    return {
      staticBasePath: `${this.$baseUrl[process.env.NODE_ENV]["staticFile"]}/`,
      form: {
        visitingCard: ""
      },
      uploadFileLoading: false,
      submitLoading: false,
      applySuccess: false,
    };
  },
  computed: {
    fileInputPlaceholder() {
      return this.uploadFileLoading
        ? "上传中..."
        : this.form.visitingCard
        ? "上传成功"
        : "请上传个人名片";
    },
    uploadBtnText() {
      return this.form.visitingCard ? "更换" : "上传";
    }
  },
  methods: {
    uploadFileInputChange(e) {
      let files = event.target.files || window.event.target;
      let file = files[0] || {};

      let form = this.$refs.uploadFileForm;
      let formData = new FormData(form);
      this.uploadFileLoading = true;
      this.$http.post("file/visitingCard", formData).then(res => {
        this.uploadFileLoading = false;
        if (res.code === 20000) {
          this.$message.success("上传成功");
          this.form.visitingCard = res.data.filePath;
          this.$refs.uploadFileInput.value = "";
        } else {
          this.$message.error(`上传失败：${res.data.errorMsg}`);
        }
      });
    },
    uploadBusinessCard() {
      //如果不处于上传中状态，则进行文件上传
      if (!this.uploadFileLoading) {
        this.$refs.uploadFileInput.click();
      }
    },
    applySubmit() {
      let params = getUrlParams();
      let form = JSON.parse(JSON.stringify(this.form));

      //私募直营店 类型字段 1
      form.application = 1;
      form.source = +params.source || 101;

      if (!this.submitLoading) {
        if (!form.visitingCard) {
          this.$message.error("请上传名片");
          return false;
        }
        this.submitLoading = true;
        this.$http.post("user/probation", form).then(res => {
          this.submitLoading = false;
          if (res.code === 20000) {
            // this.$message.success('申请成功');
            this.applySuccess = true;
          } else {
            this.$message.error(`申请失败：${res.data.errorMsg}`);
          }
        });
      }
    },
    toLogin(){
      window.location.assign(this.$baseUrl[process.env.NODE_ENV]["page"] +"/login/index.html");
    }
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.apply-container{
  .info{
    font-size: .24rem;
    color: #fff;
    text-align: center;
    margin-top: .3rem;
  }
  .form{
    margin-top: .3rem;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius:0.03rem;
    position: relative;
    .title{
      padding-top: .2rem;
      font-size: .22rem;
      text-align: center;
    }
    .form-content{
        margin-top: .2rem;
        .submit-button{
          cursor: pointer;
          margin-top: 0.3rem;
          width: 100%;
          height: .5rem;
          line-height: .5rem;
          text-align: center;
          border-radius: 3px !important;
          background-color: #C31111;
          color: #fff;
          font-size: 0.16rem;
          font-weight: 400;
        }
    }
    .success-tip {
      text-align: center;
      margin-top: .5rem;
      .success-img {
        width: .8rem;
        height: .8rem;
      }
      .success-text {
        display: block;
        color: #fff;
        font-size: 0.18rem;
        margin: 0.2rem auto 0.5rem auto;
        text-align: center;
      }
      .success-desc {
        display: block;
        width: 100%;
        height: .5rem;
        line-height: .5rem;
        font-size: 0.14rem;
        color: #fff;
        background-color: #dd2222;
        text-align: center;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
      }
    }
  }
}
.pic-wrapper {
    box-sizing: border-box;
    text-align: center;
    background-repeat: no-repeat;
    background-position: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
.login-btn {
    color: #FFFFFF;
    border: 1px solid #BBBBBB;
}
.login-btn:hover {
    color: #3e92ff;
    border: 1px solid #3e92ff;
}
</style>



